<template>
  <div class="dialog-wrap">
    <el-dialog custom-class="writeoff-gift-dialog"
               :close-on-click-modal="false"
               :close-on-press-escape="!busy"
               :show-close="!busy"
               :visible.sync="dialogVisible"
               @close="handleClose"
               top="5vh"
               width="620px">
      <div slot="title"
           class="gift-dialog-heading">
        <div class="gift-dialog-heading__icon">
          <i class="el-icon-present"></i>
        </div>
        <div>
          <div class="gift-dialog-heading__title">核销赠送</div>
          <div class="gift-dialog-heading__subtitle">直接为机构账号创建商品核销额度</div>
        </div>
      </div>

      <div class="gift-notice">
        <i class="el-icon-info gift-notice__icon"></i>
        <div>
          <div class="gift-notice__title">本次赠送不经过采购订单</div>
          <div class="gift-notice__text">提交成功后，系统将直接生成机构核销任务。</div>
        </div>
      </div>

      <div class="gift-section-heading">
        <span>赠送信息</span>
        <small>以下信息均为必填项</small>
      </div>
      <el-form ref="dataForm"
               class="gift-form"
               :model="dataForm"
               :rules="rules"
               label-position="top">
        <el-form-item label="机构账号"
                      prop="company_user_id">
          <el-select v-model="dataForm.company_user_id"
                     :disabled="busy"
                     :loading="companyUserLoading"
                     :remote-method="handleCompanyUserSearch"
                     clearable
                     filterable
                     remote
                     reserve-keyword
                     placeholder="输入机构名称、账号名称或手机号搜索"
                     style="width: 100%">
            <el-option v-for="item in companyUserOptions"
                       :key="item.id"
                       :label="formatCompanyUserOption(item)"
                       :value="item.id">
              <div class="gift-option">
                <span class="gift-option__title">{{ formatCompanyUserName(item) }}</span>
                <span class="gift-option__meta">{{ formatCompanyUserMeta(item) }}</span>
              </div>
            </el-option>
          </el-select>
          <div class="gift-field-tip">核销额度将发放至所选机构账号</div>
        </el-form-item>

        <el-form-item label="推广商品"
                      prop="product_id">
          <el-select v-model="dataForm.product_id"
                     :disabled="busy"
                     :loading="productLoading"
                     clearable
                     filterable
                     placeholder="请选择已上线的渠道分销商品"
                     style="width: 100%">
            <el-option v-for="item in productOptions"
                       :key="item.product_id"
                       :label="formatProductOption(item)"
                       :value="item.product_id">
              <div class="gift-option">
                <span class="gift-option__title">{{ formatProductName(item) }}</span>
                <span class="gift-option__meta">{{ formatProductType(item.product_type) }} · 商品ID {{ item.product_id }}</span>
              </div>
            </el-option>
          </el-select>
          <div class="gift-field-tip">仅展示已上线的渠道分销商品</div>
        </el-form-item>

        <el-form-item label="开课码数量"
                      prop="code_count">
          <div class="gift-count-row">
            <el-input-number v-model="dataForm.code_count"
                             :disabled="busy"
                             :min="1"
                             :max="1000"
                             :step="1"
                             :precision="0"
                             controls-position="right">
            </el-input-number>
            <span class="gift-count-unit">个</span>
          </div>
          <div class="gift-field-tip">请输入1至1000的整数，默认100</div>
        </el-form-item>
      </el-form>

      <div slot="footer"
           class="gift-dialog-footer">
        <span class="gift-dialog-footer__tip">
          <i class="el-icon-lock"></i> 仅后台管理员可操作
        </span>
        <div>
          <el-button :disabled="busy"
                     @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     :disabled="busy"
                     @click="handleSubmit">下一步</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog custom-class="writeoff-gift-confirm-dialog"
               append-to-body
               :close-on-click-modal="false"
               :close-on-press-escape="!submitting"
               :show-close="!submitting"
               :visible.sync="confirmDialogVisible"
               width="500px">
      <div class="gift-confirm">
        <div class="gift-confirm__icon">
          <i class="el-icon-warning-outline"></i>
        </div>
        <h3>确认赠送核销</h3>
        <p class="gift-confirm__subtitle">请核对以下信息，确认后将立即创建核销任务。</p>

        <div class="gift-confirm-summary">
          <div class="gift-confirm-summary__row">
            <span class="gift-confirm-summary__label">机构账号</span>
            <span class="gift-confirm-summary__value">{{ selectedCompanyUserLabel }}</span>
          </div>
          <div class="gift-confirm-summary__row">
            <span class="gift-confirm-summary__label">推广商品</span>
            <span class="gift-confirm-summary__value">
              <el-tag size="mini">{{ selectedProductType }}</el-tag>
              {{ selectedProductName }}
            </span>
          </div>
          <div class="gift-confirm-summary__row gift-confirm-summary__row--count">
            <span class="gift-confirm-summary__label">赠送数量</span>
            <span class="gift-confirm-summary__value">
              <strong>{{ dataForm.code_count }}</strong> 个
            </span>
          </div>
        </div>

        <div class="gift-confirm-risk">
          <i class="el-icon-warning"></i>
          本次操作不会生成采购订单，且创建后无法在当前页面撤销。
        </div>
      </div>
      <div slot="footer"
           class="gift-confirm-footer">
        <el-button :disabled="submitting"
                   @click="confirmDialogVisible = false">返回修改</el-button>
        <el-button type="primary"
                   :loading="submitting"
                   @click="createTask">确认赠送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { crmCompanyUserList } from '@/api/member'
import { startProductTask, warrantProductlist } from '@/api/warrant'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      confirmDialogVisible: false,
      dataForm: this.getInitialForm(),
      rules: {
        company_user_id: [
          { required: true, message: '请选择机构账号', trigger: 'change' },
        ],
        product_id: [
          { required: true, message: '请选择推广商品', trigger: 'change' },
        ],
        code_count: [
          { required: true, validator: this.validateCodeCount, trigger: 'change' },
        ],
      },
      companyUserOptions: [],
      companyUserLoading: false,
      companyUserSearchTimer: null,
      companyUserRequestId: 0,
      productOptions: [],
      productLoading: false,
      productRequestId: 0,
      submitting: false,
    }
  },
  computed: {
    busy() {
      return this.confirmDialogVisible || this.submitting
    },
    selectedCompanyUser() {
      return this.companyUserOptions.find(
        (item) => String(item.id) === String(this.dataForm.company_user_id)
      )
    },
    selectedProduct() {
      return this.productOptions.find(
        (item) => String(item.product_id) === String(this.dataForm.product_id)
      )
    },
    selectedCompanyUserLabel() {
      return this.selectedCompanyUser
        ? this.formatCompanyUserOption(this.selectedCompanyUser)
        : `机构用户 #${this.dataForm.company_user_id}`
    },
    selectedProductName() {
      return this.selectedProduct
        ? this.formatProductName(this.selectedProduct)
        : `商品 #${this.dataForm.product_id}`
    },
    selectedProductType() {
      return this.selectedProduct
        ? this.formatProductType(this.selectedProduct.product_type)
        : '商品'
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
      if (value) {
        this.fetchCompanyUserOptions('')
        this.fetchProductOptions()
      }
    },
  },
  beforeDestroy() {
    this.clearCompanyUserSearchTimer()
  },
  methods: {
    getInitialForm() {
      return {
        company_user_id: null,
        product_id: null,
        code_count: 100,
      }
    },
    validateCodeCount(rule, value, callback) {
      const count = Number(value)
      if (!Number.isInteger(count) || count < 1 || count > 1000) {
        callback(new Error('开课码数量请输入1至1000的整数'))
        return
      }
      callback()
    },
    handleCompanyUserSearch(keyword) {
      this.clearCompanyUserSearchTimer()
      this.companyUserSearchTimer = setTimeout(() => {
        this.fetchCompanyUserOptions(keyword)
      }, 300)
    },
    fetchCompanyUserOptions(keyword) {
      const requestId = ++this.companyUserRequestId
      this.companyUserLoading = true
      crmCompanyUserList({ keyword: String(keyword || '').trim() })
        .then((res) => {
          if (requestId !== this.companyUserRequestId) return
          const list = res && Array.isArray(res.list) ? res.list : []
          const selected = this.selectedCompanyUser
          if (selected && !list.some((item) => String(item.id) === String(selected.id))) {
            this.companyUserOptions = [selected].concat(list)
          } else {
            this.companyUserOptions = list
          }
        })
        .catch(() => {})
        .finally(() => {
          if (requestId === this.companyUserRequestId) {
            this.companyUserLoading = false
          }
        })
    },
    fetchProductOptions() {
      const requestId = ++this.productRequestId
      this.productLoading = true
      warrantProductlist({ foster_types: '1', isPaging: 0 })
        .then((res) => {
          if (requestId !== this.productRequestId) return
          const list = res && Array.isArray(res.list) ? res.list : []
          const products = {}
          list.forEach((item) => {
            if (
              Number(item.foster_type) === 1 &&
              Number(item.status) === 1 &&
              item.product_id !== null &&
              item.product_id !== undefined &&
              item.product_id !== '' &&
              !products[String(item.product_id)]
            ) {
              products[String(item.product_id)] = item
            }
          })
          this.productOptions = Object.keys(products).map((key) => products[key])
        })
        .catch(() => {})
        .finally(() => {
          if (requestId === this.productRequestId) {
            this.productLoading = false
          }
        })
    },
    formatCompanyUserName(item) {
      return item.company_name || item.alias || item.phone || `机构用户 #${item.id}`
    },
    formatCompanyUserMeta(item) {
      const parts = [item.alias, item.phone, `ID ${item.id}`].filter(
        (value) => value !== null && value !== undefined && String(value).trim() !== ''
      )
      return parts.join(' · ')
    },
    formatCompanyUserOption(item) {
      const parts = [item.company_name, item.alias, item.phone].filter(
        (value) =>
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ''
      )
      return parts.length ? parts.join('/') : `机构用户 #${item.id}`
    },
    formatProductName(item) {
      return item.product_name || item.code_product_name || '未命名商品'
    },
    formatProductOption(item) {
      return `${this.formatProductName(item)}/${this.formatProductType(item.product_type)}/商品ID：${item.product_id}`
    },
    formatProductType(value) {
      return ({ 1: '课程', 2: '题库', 3: '专栏', 4: '资料' })[Number(value)] || '其他'
    },
    handleSubmit() {
      if (this.busy) return
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return
        this.confirmDialogVisible = true
      })
    },
    createTask() {
      if (this.submitting) return
      const params = {
        product_id: this.dataForm.product_id,
        code_count: Number(this.dataForm.code_count),
        company_user_id: this.dataForm.company_user_id,
      }
      this.submitting = true
      startProductTask(params)
        .then((res) => {
          if (!res || typeof res === 'string') return
          this.confirmDialogVisible = false
          this.$message.success('核销赠送成功')
          this.$emit('submit')
          this.dialogVisible = false
        })
        .catch(() => {})
        .finally(() => {
          this.submitting = false
        })
    },
    clearCompanyUserSearchTimer() {
      if (this.companyUserSearchTimer) {
        clearTimeout(this.companyUserSearchTimer)
        this.companyUserSearchTimer = null
      }
    },
    resetForm() {
      this.clearCompanyUserSearchTimer()
      this.companyUserRequestId += 1
      this.productRequestId += 1
      this.companyUserOptions = []
      this.productOptions = []
      this.companyUserLoading = false
      this.productLoading = false
      this.confirmDialogVisible = false
      this.submitting = false
      this.dataForm = this.getInitialForm()
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
    },
    handleClose() {
      this.resetForm()
      this.$emit('close')
    },
  },
}
</script>

<style lang="less">
.writeoff-gift-dialog,
.writeoff-gift-confirm-dialog {
  overflow: hidden;
  border-radius: 10px;

  .el-dialog__header {
    padding: 22px 28px 18px;
    border-bottom: 1px solid #ebeef5;
  }
  .el-dialog__body {
    padding: 24px 28px;
  }
  .el-dialog__footer {
    padding: 16px 28px;
    border-top: 1px solid #ebeef5;
    background: #fafbfc;
  }
}

.gift-dialog-heading {
  display: flex;
  align-items: center;
  padding-right: 28px;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    margin-right: 12px;
    color: #409eff;
    font-size: 21px;
    background: #ecf5ff;
    border-radius: 10px;
  }
  &__title {
    color: #303133;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  &__subtitle {
    margin-top: 2px;
    color: #909399;
    font-size: 13px;
    line-height: 18px;
  }
}

.gift-notice {
  display: flex;
  padding: 14px 16px;
  margin-bottom: 24px;
  background: #f4f8ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;

  &__icon {
    margin: 2px 10px 0 0;
    color: #409eff;
    font-size: 17px;
  }
  &__title {
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  &__text {
    margin-top: 3px;
    color: #606266;
    font-size: 13px;
    line-height: 20px;
  }
}

.gift-section-heading {
  display: flex;
  align-items: baseline;
  margin-bottom: 16px;
  color: #303133;
  font-size: 15px;
  font-weight: 600;

  &::before {
    width: 3px;
    height: 14px;
    margin-right: 8px;
    background: #409eff;
    border-radius: 2px;
    content: '';
  }
  small {
    margin-left: 10px;
    color: #a8abb2;
    font-size: 12px;
    font-weight: normal;
  }
}

.gift-form {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__label {
    padding-bottom: 8px;
    color: #606266;
    font-weight: 500;
    line-height: 20px;
  }
}

.gift-field-tip {
  margin-top: 5px;
  color: #a8abb2;
  font-size: 12px;
  line-height: 18px;
}

.gift-count-row {
  display: flex;
  align-items: center;

  .el-input-number {
    width: 220px;
  }
}

.gift-count-unit {
  margin-left: 10px;
  color: #606266;
}

.gift-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 520px;

  &__title {
    overflow: hidden;
    margin-right: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__meta {
    flex-shrink: 0;
    color: #909399;
    font-size: 12px;
  }
}

.gift-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__tip {
    color: #909399;
    font-size: 12px;
  }
}

.writeoff-gift-confirm-dialog {
  .el-dialog__header {
    min-height: 18px;
    padding-bottom: 0;
    border-bottom: 0;
  }
  .el-dialog__body {
    padding-top: 8px;
  }
}

.gift-confirm {
  text-align: center;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    margin: 0 auto 14px;
    color: #e6a23c;
    font-size: 28px;
    background: #fdf6ec;
    border-radius: 50%;
  }
  h3 {
    margin: 0;
    color: #303133;
    font-size: 20px;
    font-weight: 600;
  }
  &__subtitle {
    margin: 8px 0 20px;
    color: #909399;
    font-size: 13px;
    line-height: 20px;
  }
}

.gift-confirm-summary {
  padding: 4px 18px;
  text-align: left;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-radius: 8px;

  &__row {
    display: flex;
    align-items: flex-start;
    padding: 13px 0;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border-bottom: 0;
    }
    &--count strong {
      margin-right: 3px;
      color: #409eff;
      font-size: 22px;
    }
  }
  &__label {
    flex: 0 0 72px;
    color: #909399;
    font-size: 13px;
  }
  &__value {
    flex: 1;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;

    .el-tag {
      margin-right: 6px;
    }
  }
}

.gift-confirm-risk {
  padding: 11px 13px;
  margin-top: 16px;
  color: #b88230;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  background: #fdf6ec;
  border-radius: 5px;

  i {
    margin-right: 5px;
  }
}

.gift-confirm-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
